//var mainCat = '';
//var subCat = '';
//var pageType = '';
//var viewType = '';
//var stepNo = 1;

//function SetPageTypeAndCatNames(_pageType) {

//    if (_pageType == "") {
//        pageType = $("#PgType").val();
//    }

//    viewType = "Kategori Sayfaları";

//    switch (pageType) {

//        case 'Cat': pageType = "Category"; break;
//        case 'Prd': pageType = "Detail"; viewType = "Ürün Detay Sayfaları"; break;
//        case 'SiparisSepetAdimi': pageType = "Basket"; stepNo = 1; break;
//        case 'SiparisAdresAdimi': pageType = "Adress"; stepNo = 3; break;
//        case 'SiparisOdemeAdimi': pageType = "Payment"; stepNo = 5; break;
//        case 'SiparisBasariliAdimi': pageType = "PaymentSuccess"; stepNo = 6; break;
//        case 'SiparisBasarisizAdimi': pageType = "PaymentFail"; stepNo = 7; break;
//    }

//    if ($(".OnSearch").length > 0) {
//        pageType = "Search Result";
//    }

//    var location = window.location.pathname;
//    if (location == "/" || location == "") {
//        pageType = "Home";
//    }


//    if ($(".CategoryBannerContent").length > 0) {

//        if ($(".CategoryBannerContent h2:first").length > 0) mainCat = $(".CategoryBannerContent h2:first").text().replace(/^\s+|\s+$/g, '');
//        if ($(".CategoryBannerContent h2 a:first").length > 0) mainCat = $(".CategoryBannerContent h2 a:first").text().replace(/^\s+|\s+$/g, '');
//        if ($(".CategoryBannerContent h1:first").length > 0 && $(".CategoryBannerContent h2 a:first").length > 0) subCat = $(".CategoryBannerContent h1:first").text().replace(/^\s+|\s+$/g, '');
//        if ($(".CategoryBannerContent h1:first").length > 0 && $(".CategoryBannerContent h2 a:first").length <= 0) mainCat = $(".CategoryBannerContent h1:first").text().replace(/^\s+|\s+$/g, '');

//    }

//    if ($("#MainNavBrd").length > 0) {

//        if ($("#MainNavBrd a:gt(0):first h2").length > 0) mainCat = $("#MainNavBrd a:gt(0):first h2").text().replace(/^\s+|\s+$/g, '').trim();
//    }



//    if ($(".OnSearch").length > 0) {
//        viewType = "Arama Sonuç Sayfaları";
//    }


//}
//function SendGaDataLayerVirtual() {

//    dataLayer.push({
//        'event': 'GAVirtual'
//    });

//    console.log(dataLayer);

//}

//function AddGeneralInfoTagManager(_pageType, dtIsLogged, dtUserID) {


//    SetPageTypeAndCatNames(_pageType);

//    dataLayer.push({
//        'loginStatus': dtIsLogged,
//        'userID': dtUserID,
//        'pageType': pageType,
//        'mainCategory': mainCat,
//        'subCategory': subCat

//    });

//    //dataLayer.push({
//    //    'event': 'GAVirtual'
//    //});

//    //console.log("loginStatus:" + dtIsLogged + " userID:" + dtUserID + " pageType:" + pageType + " mainCat:" + mainCat + " subCat" + subCat);
//}

//function AddProductView(_pageType) {

//    if ($(".ProductDetail").length > 0) {

//        SetPageTypeAndCatNames(_pageType);

//        //if ($(".ProductDetail").length > 0) {

//        var prdCode = $(".ProductContent .PrdouctCode:first").text().replace("ÜRÜN KODU :", "").replace("PRODUCT CODE :", "").replace(/(\r\n|\n|\r)/gm, "").trim();
//        var prdName = $(".ProductContent .ProductHeader:first").text().replace(/(\r\n|\n|\r)/gm, "").trim();
//        var prdPrice = $(".ProductContent .Price:first").text().replace(/(\r\n|\n|\r)/gm, "").replace(",", ".").replace("TL", "").trim();

//        var subCatForClick = subCat;

//        if ((subCatForClick == undefined || subCatForClick == "") && (mainCat != undefined && mainCat.length > 0)) {
//            subCatForClick = mainCat;
//        }

//        dataLayer.push({
//            'ecommerce': {
//                'detail': {
//                    'actionField': { list: viewType }, //Vitrin ismi şunlardan biri olmalı (Ana Sayfa – Blok İsmi, Kategori Sayfaları, Kombin Sayfaları ve Arama Sonuç Sayfaları)
//                    'products': [{
//                        'id': prdCode, //Ürün Kodu
//                        'name': prdName, //Ürün İsmi
//                        'price': prdPrice, //Ürün Fiyatı
//                        'category': subCatForClick //En Alt Ürün Kategorisi
//                    }]
//                }
//            }
//        });

//    }

//}


//function SendCartAddEvent(_pageType) {

//    SetPageTypeAndCatNames(_pageType);

//    //if ($(".ProductDetail").length > 0) {

//    var prdCode = $(".ProductContent .PrdouctCode:first").text().replace("ÜRÜN KODU :", "").replace("PRODUCT CODE :", "").replace(/(\r\n|\n|\r)/gm, "").trim();
//    var prdName = $(".ProductContent .ProductHeader:first").text().replace(/(\r\n|\n|\r)/gm, "").trim();
//    var prdPrice = $(".ProductContent .Price:first").text().replace(/(\r\n|\n|\r)/gm, "").replace(",", ".").replace("TL", "").trim();
//    var colorName = $(".Colors a.active").attr("title").trim();
//    var sizeName = $(".SizeOptions  a.active").text().trim();

//    var subCatForClick = subCat;

//    if ((subCatForClick == undefined || subCatForClick == "") && (mainCat != undefined && mainCat.length > 0)) {
//        subCatForClick = mainCat;
//    }


//    dataLayer.push({
//        'event': 'GAEvent',
//        'eventCategory': 'Cart',
//        'eventAction': 'Add',
//        'ecommerce': {
//            'add': {
//                'actionField': { list: viewType }, //Vitrin ismi şunlardan biri olmalı (Ana Sayfa – Blok İsmi, Kategori Sayfaları, Kombin Sayfaları ve Arama Sonuç Sayfaları)

//                'products': [{
//                    'id': prdCode, //Ürün Kodu
//                    'name': prdName, //Ürün İsmi
//                    'price': prdPrice, //Ürün Fiyatı
//                    'category': subCatForClick, //En Alt Ürün Kategorisi
//                    'variant': 'color=' + colorName + '|size=' + sizeName, //color=mid-green|size=m //Sepete eklenen ürün varyant bilgileri attribute=value formatında | işareti ile ayrılmış
//                    'quantity': 1 //Sepete eklenen adet
//                }]
//            }
//        }
//    });


//    console.log(dataLayer);

//}

//function AddUserAction(_event) {

//    dataLayer.push({
//        'event': 'GAEvent',
//        'eventCategory': 'User',
//        'eventAction': _event,
//    });

//}


//function AddFilterEvent() {

//    var filterSort = "Yeniler Önde";
//    var filterColors = "";

//    var curMaxPrice = $(".CurMaxPrice").text().replace(" TL", "").replace(/(\r\n|\n|\r)/gm, "").trim();
//    var curMinPrice = $(".CurMinPrice").text().replace(" TL", "").replace(/(\r\n|\n|\r)/gm, "").trim();

//    var filterPrice = curMinPrice + "-" + curMaxPrice;

//    $("#ColorFilters input:checked").each(function (e) {
//        filterColors += $(this).closest("li").text().replace(/(\r\n|\n|\r)/gm, "").trim() + '|';
//    });

//    var order = $("#PrdSort input:checked").first().val();

//    switch (order) {

//        case '1': filterSort = "Fiyata Göre Azalan"; break;
//        case '2': filterSort = "Fiyata Göre Artan"; break;
//        case '3': filterSort = "Yeniler Önde"; break;

//    }

//    if (filterColors.length > 0) {
//        filterColors = filterColors.substring(0, filterColors.length - 1);
//    }

//    dataLayer.push({
//        'filterSort': filterSort, //Sıralama
//        'filterColor': filterColors, //Birden fazla renk varsa | ile ayırabilir misin?
//        'filterPrice': filterPrice, //Min-Max
//    })

//    dataLayer.push({
//        'event': 'GAEvent',
//        'eventCategory': 'Listing Page',
//        'eventAction': 'Filter',
//    });

//    //console.log("filterSort:" + filterSort + " filterColors:" + filterColors + " filterPrice:" + filterPrice);

//}

//function AddCheckOutView(_pageType, _stepNo) {

//    SetPageTypeAndCatNames(_pageType);

//    //if ($(".ProductDetail").length > 0) {

//    var prdCode = $(".ProductContent .PrdouctCode:first").text().replace("ÜRÜN KODU :", "").replace("PRODUCT CODE :", "").replace(/(\r\n|\n|\r)/gm, "").trim();
//    var prdName = $(".ProductContent .ProductHeader:first").text().replace(/(\r\n|\n|\r)/gm, "").trim();
//    var prdPrice = $(".ProductContent .Price:first").text().replace(/(\r\n|\n|\r)/gm, "").replace(",", ".").replace("TL", "").trim();

//    var subCatForClick = subCat;

//    if ((subCatForClick == undefined || subCatForClick == "") && (mainCat != undefined && mainCat.length > 0)) {
//        subCatForClick = mainCat;
//    }

//    if (_stepNo != undefined && _stepNo.length > 0) {
//        stepNo = _stepNo;
//    }

//    //var productsforStep = [];
//    //var stepno=1;

//    dataLayer.push({
//        'ecommerce': {
//            'checkout': {
//                'actionField': { 'step': stepNo }, //Vitrin ismi şunlardan biri olmalı (Ana Sayfa – Blok İsmi, Kategori Sayfaları, Kombin Sayfaları ve Arama Sonuç Sayfaları)
//                'products': productsforStep
//            }
//        }
//    });


//}


//function SendCartRemoveEvent(_pageType, _RemovedItem) {

//    SetPageTypeAndCatNames(_pageType);

//    $RemovedItem = $(_RemovedItem);
//    //if ($(".ProductDetail").length > 0) {

//    var prdCode = $(".RemoveIcon", $RemovedItem).attr("data-productcode");

//    var prdName = $(".PrdName a", $RemovedItem).text();
//    var prdPrice = $(".PrdPrice", $RemovedItem).attr("title").replace(",", ".").replace("TL", "").trim();
//    var colorName = $(".PrdBarcode", $RemovedItem).text().replace(/(\r\n|\n|\r)/gm, "").trim();
//    var sizeName = $(".SizeName", $RemovedItem).text().replace(/(\r\n|\n|\r)/gm, "").trim();
//    var quantity = $(".PrdPrice", $RemovedItem).attr("data-qty");

//    var subCatForClick = subCat;

//    if ((subCatForClick == undefined || subCatForClick == "") && (mainCat != undefined && mainCat.length > 0)) {
//        subCatForClick = mainCat;
//    }


//    dataLayer.push({
//        'event': 'GAEvent',
//        'eventCategory': 'Cart',
//        'eventAction': 'Remove',
//        'ecommerce': {
//            'add': {
//                'actionField': { list: viewType }, //Vitrin ismi şunlardan biri olmalı (Ana Sayfa – Blok İsmi, Kategori Sayfaları, Kombin Sayfaları ve Arama Sonuç Sayfaları) 

//                'products': [{
//                    'id': prdCode, //Ürün Kodu
//                    'name': prdName, //Ürün İsmi
//                    'price': prdPrice, //Ürün Fiyatı
//                    'category': subCatForClick, //En Alt Ürün Kategorisi
//                    'variant': 'color=' + colorName + '|size=' + sizeName, //color=mid-green|size=m //Sepete eklenen ürün varyant bilgileri attribute=value formatında | işareti ile ayrılmış
//                    'quantity': quantity //Sepete eklenen adet
//                }]
//            }
//        }
//    });


//    console.log(dataLayer);

//}


//function AddImpression(_pageType, _promotions) {

//    SetPageTypeAndCatNames(_pageType);


//    if ($(".ProductList .Prd:not('.GaSetted')").length > 0) {

//        var products = [];
//        var i = 0;

//        $(".ProductList .Prd:not('.GaSetted')").each(function (e) {

//            $(this).addClass('GaSetted');
//            var alt = $(this).find(".img1[alt!='']").attr("alt").trim();

//            var prdlines = "";
//            var prdCode = "";

//            if (alt != undefined) {

//                prdlines = alt.split(' ');
//                prdCode = prdlines[prdlines.length - 1];

//            }

//            var prdName = $(this).find(".PName").text();
//            var prdPrice = $(this).find(".PPrice").text().replace(",", ".").replace(" TL", "");

//            if (pageType == "Home") {

//                viewType = "Anasayfa";
//                $curTab = $(this).closest(".HomeTabItem");

//                $curTabHeader = $("#CatalogTabs li:eq(" + $curTab.index() + ") .TabName");

//                viewType += " - " + $curTabHeader.text();


//            }

//            products.push({
//                'id': prdCode, //Ürün Kodu
//                'name': prdName, //Ürün İsmi
//                'price': prdPrice, //Ürün Fiyatı
//                'category': mainCat, //En Alt Ürün Kategorisi
//                'brand': 'happyshop',
//                'list': viewType, //Vitrin ismi şunlardan biri olmalı (Ana Sayfa – Blok İsmi, Kategori Sayfaları, Kombin Sayfaları ve Arama Sonuç Sayfaları)
//                'position': i //Ürün vitrinde kaçıncı sırada görüntüleniyor
//            });

//            i++;

//        });

//        if (_promotions == undefined || _promotions.length <= 0) {

//            dataLayer.push({
//                'ecommerce': {
//                    'impressions': products
//                }
//            });
//        }
//        else {
//            dataLayer.push({
//                'ecommerce': {
//                    'impressions': products,
//                    'promoView': {
//                        'promotions': _promotions
//                    }
//                }
//            });

//        }

//    }

//    //dataLayer.push({
//    //    'event': 'GAVirtual'
//    //});

//    //console.log(products);

//    // console.log("loginStatus:" + dtIsLogged + " userID:" + dtUserID + " pageType:" + pageType + " mainCat:" + mainCat + " subCat" + subCat);
//}


////AddGaEvent('', 'Product List', 'Product Click', $(this));
//function GetProductPosition(_EventObject) {

//    $Prd = $(_EventObject);
//    $products = $Prd.closest(".Products");

//    //console.log("products len:" + $products.length);
//    //console.log("prd len:" + $Prd.length);

//    var position = 0;
//    var ismatched = false;

//    $products.find(".Prd").each(function (e) {

//        if (!ismatched) {
//            if ($(this).find(" > a").attr("href") == $Prd.find(" > a").attr("href")) {
//                // alert($(this).attr("href"));
//                ismatched = true;
//                return position;
//            }

//            position++;


//        }
//        else {
//            return position;
//        }

//        // console.log(position);
//    });

//    return position;
//}

//function AddGaEvent(_pageType, _eventCategory, _eventAction, _EventObject) {

//    SetPageTypeAndCatNames(_pageType);

//    var actionDetail = [];
//    var products = [];
//    var actionName = '';

//    if (_eventAction == "Product Click" && _EventObject != undefined) {

//        actionName = 'click';

//        var alt = $(_EventObject).find(".img1[alt!='']").attr("alt").trim();

//        var prdlines = "";
//        var prdCode = "";

//        if (alt != undefined) {

//            prdlines = alt.split(' ');
//            prdCode = prdlines[prdlines.length - 1];

//        }

//        var prdName = $(_EventObject).find(".PName").text();
//        var prdPrice = $(_EventObject).find(".PPrice").text().replace(",", ".").replace(" TL", "");

//        var subCatForClick = subCat;

//        if ((subCatForClick == undefined || subCatForClick == "") && (mainCat != undefined && mainCat.length > 0)) {
//            subCatForClick = mainCat;
//        }


//        if (pageType == "Home") {

//            viewType = "Anasayfa";
//            $curTab = $(_EventObject).closest(".HomeTabItem");

//            $curTabHeader = $("#CatalogTabs li:eq(" + $curTab.index() + ") .TabName");

//            viewType += " - " + $curTabHeader.text();
//            subCatForClick = $curTabHeader.text();
//        }


//        products.push({
//            'id': prdCode, //Ürün Kodu
//            'name': prdName, //Ürün İsmi
//            'price': prdPrice, //Ürün Fiyatı
//            'category': subCatForClick, //En Alt Ürün Kategorisi
//            'brand': 'happyshop',
//            'position': GetProductPosition(_EventObject) //Ürün vitrinde kaçıncı sırada görüntüleniyor
//        });

//        //  console.log(products);

//        actionDetail = {
//            'actionField': { list: viewType }, //Vitrin ismi şunlardan biri olmalı (Ana Sayfa – Blok İsmi, Kategori Sayfaları, Kombin Sayfaları ve Arama Sonuç Sayfaları)
//            'products': products
//        };

//    }

//    //alert(actionName);

//    dataLayer.push({
//        'event': 'GAEvent',
//        'eventCategory': _eventCategory, //'Product List'
//        'eventAction': _eventAction, //'Product Click'
//        'ecommerce': {
//            'click': actionDetail
//        }
//    });

//    //console.log(dataLayer); 
//}


//function AddGASliderView(_pageType) {

//    SetPageTypeAndCatNames(_pageType);

//    var promotions = [];

//    if (pageType == "Home") {


//        $("#homebannerFull1 .CarouselImg, #homebannerFull2 .CarouselImg").each(function (e) {

//            var banid = $(this).closest(".SBanner").attr("id").replace("#", "");
//            //"http://"+ window.location.hostname +
//            var slideSrc = $(this).attr("src");

//            var bannername = "";
//            var bannerid = "";
//            var bannerpos = "";

//            switch (banid) {

//                case 'homebannerFull1': bannername = "Main Page Full Slider"; bannerid = "mainfullbanner"; bannerpos = "fullslot"; break;
//                case 'homebannerFull2': bannername = "Main Page Top Slider"; bannerid = "mainslider"; bannerpos = "sliderslot"; break;
//            }

//            promotions.push({
//                'id': bannerid, //mainfullbanner,mainslider,catbanner
//                'name': bannername, //Main Page Full Slider,Main Page Top Slider,Main Page Category Banners - Yeniler
//                'creative': slideSrc, //Banner image adresi
//                'position': bannerpos //fullslot,catbannerslot, sliderslot
//            });


//        });


//        $("#pieceBanner1, .pieceBannerMiddle1 , .pieceBannerRight1 , .pieceBannerMiddle2 , .pieceBannerRight2 ").each(function (e) {

//            //var banid = $(this).closest(".SBanner").attr("id").replace("#", "");

//            var backgrounIMG = $(this).find(" > div").css('background-image');
//            backgrounIMG = backgrounIMG.replace('url(', '').replace(')', '');
//            //"http://" + window.location.hostname + 
//            var slideSrc = backgrounIMG;

//            var bannername = "Main Page Category Banners - " + $(this).find(".middleText").text().replace(/(\r\n|\n|\r)/gm, "").trim();
//            var bannerid = "catbanner";
//            var bannerpos = "catbannerslot";

//            promotions.push({
//                'id': bannerid, //mainfullbanner,mainslider,catbanner
//                'name': bannername, //Main Page Full Slider,Main Page Top Slider,Main Page Category Banners - Yeniler
//                'creative': slideSrc, //Banner image adresi
//                'position': bannerpos //fullslot,catbannerslot, sliderslot
//            });



//        });


//        dataLayer.push({
//            'ecommerce': {
//                'promoView': {
//                    'promotions': promotions
//                }
//            }
//        });
//    }

//}

//function GetPromotionsVariable(_pageType) {

//    SetPageTypeAndCatNames(_pageType);

//    var promotions = [];

//    if (pageType == "Home") {


//        $("#homebannerFull1 .CarouselImg, #homebannerFull2 .CarouselImg").each(function (e) {

//            var banid = $(this).closest(".SBanner").attr("id").replace("#", "");
//            //"http://"+ window.location.hostname +
//            var slideSrc = $(this).attr("src");

//            var bannername = "";
//            var bannerid = "";
//            var bannerpos = "";

//            switch (banid) {

//                case 'homebannerFull1': bannername = "Main Page Full Slider"; bannerid = "mainfullbanner"; bannerpos = "fullslot"; break;
//                case 'homebannerFull2': bannername = "Main Page Top Slider"; bannerid = "mainslider"; bannerpos = "sliderslot"; break;
//            }

//            promotions.push({
//                'id': bannerid, //mainfullbanner,mainslider,catbanner
//                'name': bannername, //Main Page Full Slider,Main Page Top Slider,Main Page Category Banners - Yeniler
//                'creative': slideSrc, //Banner image adresi
//                'position': bannerpos //fullslot,catbannerslot, sliderslot
//            });


//        });


//        $("#pieceBanner1, .pieceBannerMiddle1 , .pieceBannerRight1 , .pieceBannerMiddle2 , .pieceBannerRight2 ").each(function (e) {

//            //var banid = $(this).closest(".SBanner").attr("id").replace("#", "");

//            var backgrounIMG = $(this).find(" > div").css('background-image');
//            backgrounIMG = backgrounIMG.replace('url(', '').replace(')', '');
//            //"http://" + window.location.hostname + 
//            var slideSrc = backgrounIMG;

//            var bannername = "Main Page Category Banners - " + $(this).find(".middleText").text().replace(/(\r\n|\n|\r)/gm, "").trim();
//            var bannerid = "catbanner";
//            var bannerpos = "catbannerslot";

//            promotions.push({
//                'id': bannerid, //mainfullbanner,mainslider,catbanner
//                'name': bannername, //Main Page Full Slider,Main Page Top Slider,Main Page Category Banners - Yeniler
//                'creative': slideSrc, //Banner image adresi
//                'position': bannerpos //fullslot,catbannerslot, sliderslot
//            });



//        });

//        return promotions;

//        //dataLayer.push({
//        //    'ecommerce': {
//        //        'promoView': {
//        //            'promotions': promotions
//        //        }
//        //    }
//        //});
//    }

//}

//function AddGaPromoClick(_pageType, _EventObject) {

//    SetPageTypeAndCatNames(_pageType);

//    var promotionsforClick = [];

//    //console.log("SBannerlen:" + $(_EventObject).closest(".SBanner").length);

//    if (_EventObject != undefined) {


//        if ($(_EventObject).closest(".SBanner").length > 0) {

//            var banid = $(_EventObject).closest(".SBanner").attr("id").replace("#", "");
//            var slideSrc = $(_EventObject).closest(".SBanner").find(".CarouselImg").attr("src");

//            var bannername = "";
//            var bannerid = "";
//            var bannerpos = "";

//            switch (banid) {

//                case 'homebannerFull1': bannername = "Main Page Full Slider"; bannerid = "mainfullbanner"; bannerpos = "fullslot"; break;
//                case 'homebannerFull2': bannername = "Main Page Top Slider"; bannerid = "mainslider"; bannerpos = "sliderslot"; break;
//            }

//            promotionsforClick.push({
//                'id': bannerid, //mainfullbanner,mainslider,catbanner
//                'name': bannername, //Main Page Full Slider,Main Page Top Slider,Main Page Category Banners - Yeniler
//                'creative': slideSrc, //Banner image adresi
//                'position': bannerpos //fullslot,catbannerslot, sliderslot
//            });


//        }


//        if ($(_EventObject).closest(".PieceBanners").length > 0) {


//            var backgrounIMG = $(_EventObject).closest(".PieceBanners").find(" > div").css('background-image');
//            backgrounIMG = backgrounIMG.replace('url(', '').replace(')', '');
//            var slideSrc = backgrounIMG;

//            var bannername = "Main Page Category Banners - " + $(_EventObject).closest(".PieceBanners").find(".middleText").text().replace("İncele", "").replace(/(\r\n|\n|\r)/gm, "").trim();
//            var bannerid = "catbanner";
//            var bannerpos = "catbannerslot";

//            promotionsforClick.push({
//                'id': bannerid, //mainfullbanner,mainslider,catbanner
//                'name': bannername, //Main Page Full Slider,Main Page Top Slider,Main Page Category Banners - Yeniler
//                'creative': slideSrc, //Banner image adresi
//                'position': bannerpos //fullslot,catbannerslot, sliderslot
//            });


//        }


//        dataLayer.push({
//            'event': 'GAEvent',
//            'eventCategory': 'Home Page',
//            'eventAction': 'Click Promotion',
//            'eventLabel': 'Home Page All Banners',
//            'ecommerce': {
//                'promoClick': {
//                    'promotions': promotionsforClick
//                }
//            }
//        });

//    }


//}

//$(document).ready(function () {

//    //if ($(".ProductDetail").length > 0) {

//    //    //alert("aaaaaaa");
//    //    AddProductView('');
//    //    SendGaDataLayerVirtual();
//    //}

    

//    $("#pieceBanner1 a, .pieceBannerMiddle1 a, .pieceBannerRight1 a, .pieceBannerMiddle2 a, .pieceBannerRight2 a, #homebannerFull1 .item a, #homebannerFull2 .item a ").live("click", function (e) {


//        if (UseTagManager) {

//            AddGaPromoClick('', $(this));
//            //SendGaDataLayerVirtual(); //EVENT'ta gerek yok
//        }

//        return false;
//        e.preventDefault();


//    });


//});